import AppSettingsTemplate from './appSettings.template';

const developmentAppSettings: AppSettingsTemplate = {
  version: 'v1.3',
  auth0: {
    domain: 'stingray-staging.eu.auth0.com',
    clientId: 'nnB6OfRmBtqbcxZwCpMnLKgOzrCSmrzB',
    audience: 'https://stingrayapis.skywater.io/',
    scope: `openid profile Read:EquipmentPlacementFleet
    ReadWrite:NavigatorCommands
    Read:NavigatorPositions
    Read:NodesVideoStreams
    Read:NodesDataStreams
    Read:NavigatorCommands
    ReadWrite:NavigatorSchedules
    ReadWrite:NavigatorThrusters`,
  },
  apis: {
    mobileapi: {
      url: 'https://localhost:44309/api/v1/',
    },
    authService: {
      url: 'https://localhost:44309/api/v1/authservice',
    },
    streamservice: {
      url: 'https://staging-stream-service-subscribers.skywater.io/hubs/subscriber',
    },
  },
};

export default developmentAppSettings;
